<template>
  <div class="page-container">
    <div class="content-wrap content-wrap--dict-feed" v-if="!maintenaceWindow">
      <TopNavBar
      v-bind:secondTierLoadingDone="secondTierLoadingDone"/>
      <b-container fluid class="content ga-navbar-container">
        <div class="ga-layout-row ga-layout-row--page">
          <div class="ga-layout-gutter--left d-none d-lg-block" aria-hidden="true"></div>
          <list
            v-on:secondTierLoadingDone="secondTierLoadingDone=true"
            :filter-by="'all'"
            :hide-inline-search="true"
            class="ga-layout-main ga-layout-main--table col-12"
            style="min-width: 250px;"/>
          <div class="ga-layout-gutter--right d-none d-lg-block" aria-hidden="true"></div>
        </div>
      </b-container>
    </div>
    <div v-if="maintenaceWindow">
      <MaintenanceWindow/>
    </div>
    <GenderAppFooter/>
  </div>
</template>

<script>
// @ is an alias to /src
import TopNavBar from '../components/TopNavBar'
import List from '../components/List'
import GenderAppFooter from '../components/Footer'
import MaintenanceWindow from './MaintenanceWindow'
import { MAINTENANCE_WINDOW } from '@/env'

export default {
  name: 'Home',
  data () {
    return {
      secondTierLoadingDone: false,
      maintenaceWindow: false
    }
  },
  components: {
    GenderAppFooter,
    List,
    TopNavBar,
    MaintenanceWindow
  },
  created () {
    this.maintenaceWindow = MAINTENANCE_WINDOW === 'true'
  },

  methods: {
  }
}
</script>
<style scoped>
  .content {
    flex: auto;
  }
</style>
